






















































































import { Component, Vue, Prop } from "vue-property-decorator";

/**
 * Utils
 */
import * as imageLinks from "@/config/image-links";
import presenceItems, { PresenceItem } from "@/config/presence-items";
import { signupStates } from "@/config/presence-items";
import { GetCompositionGroupsResponse } from "@/api/compositions/get-composition-groups.response";
import { SignupState } from "@/api/compositions/signup-state";
import { Guid } from "@/domain/guid";

/**
 * Helpers
 */

/**
 * Mixins
 */

/**
 * Components
 */

/**
 * Calendar cell day list.
 */
@Component
export default class CalendarDayList extends Vue {
	/// Injections
	imageLinks = imageLinks;
	presenceItems = presenceItems;
	signupStates = signupStates;

	/// Properties
	@Prop()
	compositionGroup!: GetCompositionGroupsResponse.CompositionGroup;

	@Prop()
	onContextMenu!: (id: Guid, ev: PointerEvent) => void;

	@Prop({
		default: false,
		type: Boolean
	})
	isEditMode!: boolean;

	@Prop()
	onSignup!: (compositionGroupID: Guid, newSignupState: SignupState) => Promise<void>;

	isLoading = false;

	get signupState(): PresenceItem | null {
		return this.compositionGroup.mySignup ? (presenceItems.find(x => x.id === this.compositionGroup.mySignup.signupState) || null) : null;
	}

	async handleSignupClick(newSignupState: SignupState) {
		this.isLoading = true;
		try {
			await this.onSignup(this.compositionGroup.id, newSignupState);
		} catch (error) {
			this.handleAPIError(error);
		}
		this.isLoading = false;
	}
}
